import React, { useState, useContext } from "react";
import { useHistory, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Spinner from "../../../components/Spinner";
import { checkConnectionStatus } from "../../../utils/Common";
import AuthContext from "../../../contexts/auth";
import SidebarContext from "../../../contexts/sidebar";
import packageJson from '../../../../package.json';
import "./index.css";
import "../index.css";
import {translate} from "../../../utils/Common";
import { FaEye, FaEyeSlash, FaLock, FaUser } from "react-icons/fa";
import NotifyC from "../../../components/Notifications";

const SignIn = () => {
	const userContext = useContext(AuthContext);
	const sidebarContext = useContext(SidebarContext)
	const history = useHistory();
	const { register, handleSubmit, errors, reset, setError } = useForm();
	const [isServerRun,setIsServerRun] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [message,setMessage] = useState();
	const [showPassword, setShowPassword] = useState(false); 

	const onSubmit = async (data) => {
		setMessage('');
		setIsServerRun(false);
		setIsLoading(true);
		const result = await userContext.signIn(data);
		setIsLoading(false);
		
		switch (result) {
		case 'LOGIN_SUCCESS':
			reset();
			sidebarContext.handleChangeCurrentPage("Inicio");
			NotifyC.success("¡Inicio de sesión exitoso!", { duration: 4000 });
			history.push('/dashboard');
			break;
		case 'PASSWORD_INVALID':
			setError('pwd', { type: '', message: "Contraseña incorrecta" });
			NotifyC.error("La contraseña es incorrecta", { duration: 3000 });
			setIsServerRun(true);
			break;
		case 'USER_NOT_FOUND':
			setError('username', { type: '', message: "Usuario incorrecto" });
			NotifyC.error("El usuario no existe", { duration: 3000 });
			setIsServerRun(true);
			break;
		case 'EMAIL_NOT_FOUND':
			setError('username', { type: '', message: "Email incorrecto" });
			NotifyC.error("El email no existe", { duration: 0 });
			setIsServerRun(true);
			break;
		case 'USER_INACTIVATED':
			setError('username', { type: '', message: "Tu usuario se encuentra inactivo" });
			NotifyC.error("Tu usuario se encuentra inactivo", { duration: 3000 });
			setIsServerRun(true);
			break;
		case 'USER_NOT_VERIFIED':
			setError('username', { type: '', message: "Usuario en espera de verificación" });
			NotifyC.error("Tu usuario se encuentra en espera de verificación", { duration: 3000 });
			setIsServerRun(true);
			break;
		case 'SERVER_ERROR':
			if (checkConnectionStatus()) {
				setMessage(translate("Ops! Algo anda mal, por favor recarga la página e intenta de nuevo en unos minutos."));
				NotifyC.error("Ops! Algo anda mal, por favor recarga la página e intenta de nuevo en unos minutos.", { duration: 0 });
			}
			else {
				setMessage("Oh! Al parecer no estás conectado a internet.");
			}
			setIsServerRun(false);
			break;
		
		default:
			break;
		}
	};

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	return (
		<div className="login d-flex align-items-center justify-content-center" style={{ background: "linear-gradient(to top, #dfe9f3 0%, white 100%)" }}>
			<form className="signin-form shadow text-center" onSubmit={handleSubmit(onSubmit)}>
				<img src="../img/design-correso-login.png" alt="correos" width={"100%"} />
				<div style={{ padding: "0 3rem 3rem" }}>
					<img src="../img/logo-correos.png" className="mb-3" alt="correos" width={"65%"} />
					<h6 className="mb-2 font-weight-normal">Por favor inicia sesión</h6>

					<div className="form-group input-icon">
						<FaUser className="icon-left" />
						<input
							disabled={!isServerRun}
							type="username"
							className={"input-signin form-control rounded-pill form-control-lg" + (errors.username ? " is-invalid" : "")}
							name="username"
							placeholder={"Usuario"}
							required
							autoFocus
							ref={register({
								minLength: {
									value: 6,
									message: "El nombre de usuario debe tener mínimo 6 caracteres"
								},
								maxLength: {
									value: 20,
									message: "El nombre de usuario debe tener máximo 20 caracteres"
								}
							})}
						/>
						<div style={{ minHeight: "0" }}>
       					 {errors.username && <div className="invalid-feedback">{errors.username.message}</div>}
   					    </div>
					</div>

					<div className="form-group input-icon">
						<FaLock className="icon-left" />
						<input
							disabled={!isServerRun}
							type={showPassword ? "text" : "password"} 
							className={"input-signin form-control rounded-pill form-control-lg" + (errors.pwd ? " is-invalid" : "")}
							name="pwd"
							placeholder={"Contraseña"}
							required
							ref={register({
								minLength: {
									value: 8,
									message: "La contraseña debe tener más de 8 caracteres"
								},
								maxLength: {
									value: 12,
									message: "La contraseña debe tener menos de 12 caracteres"
								}
							})}
						/>
						<span className="icon-right" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
							{showPassword ? <FaEyeSlash /> : <FaEye />}
						</span>
						<div style={{ minHeight: "0" }}>
        {errors.pwd && <div className="invalid-feedback">{errors.pwd.message}</div>}
    </div>					</div>

					<div className="mb-2">
						<Link to="/forgotpwd" className="link font-small">{"Olvidé mi contraseña"}</Link>
					</div>

					<button disabled={!isServerRun} className="btn btn-blue btn-login btn-block rounded-pill btn-lg text-uppercase" type="submit">
						{!isLoading ? "Iniciar sesión"  : <Spinner type={1} size={18} />}
					</button>

					<div className="text-center">
						<p className="text-muted font-xsmall mb-0 mt-1">v{packageJson.version}</p>
					</div>

					{message && <div className="text-center mt-3"><span className="text-danger font-xsmall">{message}</span></div>}
				</div>
			</form>
		</div>
	);
};

export default SignIn;
